import { BaseService } from "./../../base";
export class ConsultationService extends BaseService {
  static get entity() {
    return "consultation";
  }
  static get name() {
    return "consultation";
  }

  //TODO elegir getByNodeAndServiceNode o getByNodeServiceNode
  static async getByNodeAndServiceNode(node_id, service_node_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id_service_node_id/${node_id}/${service_node_id}`, this.name);
  }
  static async getByNodeAndServiceNodeV2(node_id, service_node_id) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id_service_node_id_v2/${node_id}/${service_node_id}`,
      this.name
    );
  }
  static async getByNode(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id/${id}`, this.name);
  }
  static async getByNodeServiceNode(payload) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id_service_node_id/${payload.node_id}/${payload.service_node_id}`,
      this.name
    );
  }
  static async postByNodeService(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_service_node`, this.name, payload);
  }
  static getByFilter(node_id, service_node_id, location_id, state) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter`, this.name, {
      node_id: node_id,
      service_node_id: service_node_id,
      location_id: location_id,
      state: state,
    });
  }
  static async getByProfessionalWithCitations(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_professional_with_citations`, this.name, payload);
  }
  static async getByServiceWithCitations(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_service_with_citations`, this.name, payload);
  }
}
